import Utils from "./Utils";
import Cookies from "js-cookie";

declare global {
    interface Window {
        dataLayer: any[];
    }
}

enum DeviceType {
    MOBILE = 'mobile',
    TABLET = 'tablet',
    DESKTOP = 'desktop',
}

export default class Tracking {
    private static getDeviceType(): DeviceType {
        const userAgent = navigator.userAgent;
        const istouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        const width = window.innerWidth;

        if (/mobile/i.test(userAgent) || (istouch && width <= 768)) {
            return DeviceType.MOBILE;
        } else if (/tablet/i.test(userAgent) || (istouch && width <= 1024)) {
            return DeviceType.TABLET;
        } else {
            return DeviceType.DESKTOP;
        }
    }

    public static getUid(): string {
        let uid = Cookies.get('reuid');

        if (!uid) {
            uid = crypto.randomUUID();
            Cookies.set('reuid', uid, {
                expires: 30,
            });
        }

        return uid;
    }

    public static async init() {
        this.getUid();
    }

    public static async doPageView() {
        try {
            await this.doTrk('page_view', {
                cookie_id: this.getUid(),
                page_url: window.location.href,
                page_title: document.title,
                referrer: document.referrer,
                device_type: this.getDeviceType(),
                language: navigator.language,
                time_stamp: new Date().getTime(),
                user_agent: navigator.userAgent,
            });
        } catch (e) {
        }
    }

    public static async doTrk(name: string, data?: any) {
        console.log('trk', data);

        return Utils.post('/api/trk/collect', {
            k: name,
            v: data,
        });
    }

    public static async doEvent(name: string, data?: any) {
        return new Promise((res, err) => {
            data = Object.assign({
                event: name,
            }, data);

            console.log('DL', data);

            if (!window.dataLayer) {
                window.dataLayer = [];
            }

            window.dataLayer.push(data);

            setTimeout(() => {
                res(true);
            }, 1);
        });
    }

    public static link(selector: string, name: string): void {
        $(selector).on('click', async function (e) {
            e.preventDefault();

            await Tracking.doEvent(name);

            window.location = $(this).prop('href');
        });
    }
}
